import styled from 'styled-components';

export const WrapperTrash = styled.div`
  background: var(--chakra-colors-purple50);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: var(--chakra-colors-grey);
  border-radius: 20px;
  padding: 30px;
  width: 100%;
  height: calc(100% - 30px);
`;